import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import Fingerprint2 from 'fingerprintjs2';
import { environment, clientId } from 'src/app/features/proof-of-life/env/environment';
import User from '../user-auth/User';
import { UserAuthIamService } from '../user-auth-iam/user-auth-iam.service';
import { EventEmitter } from 'events';

declare let separm: any;

export interface Device {
    fingerprint: string;
    hdim: string;
}

interface DeviceTokenCookie {
    name: string;
    value: string;
}

export interface DeviceTokenType {
    deviceId?: string;
    deviceFingerprint: string;
    DeviceInsightTransaction: {
        hdim: string;
        date: string;
        cookies: DeviceTokenCookie[];
    };
    hasMfa?: boolean;
}

export interface NewDevice {
    deviceId: string;
    deviceTokenId: string;
}

@Injectable({
    providedIn: 'root'
})
export class DeviceService {
    private _fingerprint = '';
    private _hdim = '';
    private _deviceId = '';
    public _event = new EventEmitter();

    constructor(private http: HttpClient, private cookieService: CookieService, private iamService: UserAuthIamService) {
        this.initialize();
    }

    public initialize() {
        try {
            separm.initiate(null);
            separm.seform('hdnJsc');
            separm.seform('user_prefs2');
        } catch (error) {
            //throw error('separm script not found');
        }
    }

    get fingerprint() {
        return this._fingerprint;
    }

    get hdim() {
        return this._hdim;
    }

    get deviceId() {
        return this._deviceId;
    }

    public generateFingerPrint() {
        // hdim é gerados automaticamente pelo script prefs_se.js
        this._hdim = this.readInput('#user_prefs2');

        return new Observable<User>(observer => {
            try {
                setTimeout(() => {
                    Fingerprint2.get(components => {
                        const values = components.map(c => c.value);
                        const murmurHash = Fingerprint2.x64hash128(values.join(''), 31);
                        this._fingerprint = murmurHash;

                        observer.next(murmurHash);
                        observer.complete();
                    });
                }, 500);
            } catch (error) {
                observer.error(error);
                observer.complete();
            }
        });
    }

    public validate(deviceId: string) {
        this._deviceId = deviceId;

        return this.http.get(`${environment.deviceBasePath}/my-devices/${deviceId}`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.iamService.accessTokenJWT}`
            }
        });
    }

    public compare() {
        const params = new HttpParams().set('clientId', clientId.disputeFront);

        const data: DeviceTokenType = {
            deviceFingerprint: this._fingerprint,
            DeviceInsightTransaction: {
                hdim: this._hdim,
                date: new Date().toISOString(),
                cookies: this.cookies
            }
        };

        return this.http.post(`${environment.deviceBasePath}/my-tokens`, data, {
            params,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.iamService.accessTokenJWT}`
            }
        });
    }

    public async verifyMfa() {
        try {
            await this.generateFingerPrint().toPromise();
            const device: any = await this.compare().toPromise();
            const data: any = await this.validate(device.deviceId).toPromise();
            if (data.hasMfa) {
                this._event.emit('hasMfa', true);
            } else {
                this._event.emit('hasMfa', false);
            }
        }
        catch (err) {
            this._event.emit('hasMfa', false);
        }
    }

    private readInput(selector: string): string {
        const input: HTMLInputElement = document.querySelector(selector);
        return input ? input.value : '';
    }

    private get cookies() {
        const cookieList = this.cookieService.getAll();
        const cookies = [];

        Object.keys(cookieList).forEach(name => {
            cookies.push({
                name: name,
                value: cookieList[name]
            });
        });

        return cookies;
    }
}
